<template>
  <v-text-field
    :label="value.caption"
    prepend-icon="mdi-lock"
    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
    v-model="value.value"
    :name="value.name"
    :type="showPassword ? 'text' : 'password'"
    @click:append="showPassword = !showPassword"
    :readonly="readonly"
    autocomplete="off"
    :filled="filled"
  >
    <template #label>
      <span v-if="value.required" class="red--text"><strong>* </strong></span
      >{{ value.caption }}
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "MyFormPassword",
  data() {
    return {
      showPassword: false,
    };
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return { name: "MyFormInputNotSet", value: "", caption: "not set" };
      },
    },
    readonly: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    filled: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
  },
};
</script>

<style scoped></style>
